var React = require('react');

function Unity (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M498.11,206.4,445.31,14.72,248.2,66.08,219,116.14l-59.2-.43L15.54,256,159.82,396.32l59.17-.43,29.24,50,197.08,51.36,52.8-191.62-30-49.63ZM223.77,124.2,374.55,86.51,288,232.33H114.87Zm0,263.63L114.87,279.71H288l86.55,145.81Zm193,14L330.17,256l86.58-145.84L458.56,256Z"}));
}

Unity.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Unity;

Unity.default = Unity;
